<script setup lang="ts">
// Barre de réservation fixe, mobile uniquement : elle apparaît quand l'en-tête de page (ou, à défaut, les CTA du hero) a défilé
// et se retire dès que la section des sessions ou le pied de page est à l'écran.
const props = defineProps<{
  to: string
  label: string
  phone?: string
}>()

const heroGone = ref(false)
const targetVisible = ref(false)
const footerVisible = ref(false)
const visible = computed(() => heroGone.value && !targetVisible.value && !footerVisible.value)

const observers: IntersectionObserver[] = []

function watchElement(element: Element | null, callback: (isVisible: boolean) => void) {
  if (!element) {
    return
  }
  const observer = new IntersectionObserver(([entry]) => callback(Boolean(entry?.isIntersecting)))
  observer.observe(element)
  observers.push(observer)
}

onMounted(() => {
  watchElement(document.querySelector('.public-hero, [data-track-zone="hero"]'), isVisible => (heroGone.value = !isVisible))
  watchElement(document.querySelector(props.to), isVisible => (targetVisible.value = isVisible))
  watchElement(document.querySelector('footer'), isVisible => (footerVisible.value = isVisible))
})

onBeforeUnmount(() => observers.forEach(observer => observer.disconnect()))
</script>

<template>
  <div
    class="fixed inset-x-0 bottom-0 z-30 border-t border-[var(--line-soft)] bg-[var(--surface-1)] px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_24px_rgb(12_66_182/0.1)] transition-transform duration-300 motion-reduce:transition-none md:hidden"
    :class="visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'"
    :inert="!visible"
    data-track-zone="bar"
  >
    <div class="flex gap-3">
      <UButton
        v-if="phone"
        :to="`tel:${phone}`"
        icon="i-lucide-phone"
        label="Appeler"
        variant="outline"
        size="xl"
        class="justify-center"
      />
      <UButton
        :to="to"
        :label="label"
        size="xl"
        block
        class="flex-1 justify-center"
        data-track-key="reserver"
      />
    </div>
  </div>
</template>
